import React from "react";
import { Skeleton } from "@mui/material";
import { ViewModule, ViewStream, ViewQuilt } from "@mui/icons-material";
import { ButtonGroup, IconButton, Tooltip } from "@mui/material";
import ViewSidebarIcon from '@mui/icons-material/ViewSidebar';

const OversightSkeleton = () => {
  return (
    <div className="pl-4 pt-2">
      <div className="d-flex justify-content-end pr-3">
        <ButtonGroup size="small" aria-label="layout control">
          <Tooltip title="Default View">
            <IconButton color="default">
              <ViewModule />
            </IconButton>
          </Tooltip>
          <Tooltip title="Left Wide View">
            <IconButton color="default">
              <ViewSidebarIcon style={{ height: "21px" }}/>
            </IconButton>
          </Tooltip>
          <Tooltip title="Right Wide View">
            <IconButton color="default">
              <ViewQuilt />
            </IconButton>
          </Tooltip>
          <Tooltip title="Full View">
            <IconButton color="default">
              <ViewStream />
            </IconButton>
          </Tooltip>
        </ButtonGroup>
      </div>
      <div className="row w-100">
        <div className="col-12 col-md-6 p-0 ">
          <Skeleton
            variant="rectangle"
            width="98%"
            height={400}
            className="mx-auto mt-2 mb-2"
            style={{ borderRadius: 4 }}
          />
        </div>
        <div className="col-12 col-md-6 p-0 ">
          <Skeleton
            variant="rectangle"
            width="98%"
            height={400}
            className="mx-auto mt-2 mb-2"
            style={{ borderRadius: 4 }}
          />
        </div>
        <div className="col-12 col-md-6 p-0 ">
          <Skeleton
            variant="rectangle"
            width="98%"
            height={400}
            className="mx-auto mt-2 mb-2"
            style={{ borderRadius: 4 }}
          />
        </div>
        <div className="col-12 col-md-6 p-0 ">
          <Skeleton
            variant="rectangle"
            width="98%"
            height={400}
            className="mx-auto mt-2 mb-2"
            style={{ borderRadius: 4 }}
          />
        </div>
        <div className="col-12 col-md-6 p-0 ">
          <Skeleton
            variant="rectangle"
            width="98%"
            height={400}
            className="mx-auto mt-2 mb-2"
            style={{ borderRadius: 4 }}
          />
        </div>
        <div className="col-12 col-md-6 p-0 ">
          <Skeleton
            variant="rectangle"
            width="98%"
            height={400}
            className="mx-auto mt-2 mb-2"
            style={{ borderRadius: 4 }}
          />
        </div>
        <div className="col-12 col-md-6 p-0 ">
          <Skeleton
            variant="rectangle"
            width="98%"
            height={400}
            className="mx-auto mt-2 mb-2"
            style={{ borderRadius: 4 }}
          />
        </div>
        <div className="col-12 col-md-6 p-0 ">
          <Skeleton
            variant="rectangle"
            width="98%"
            height={400}
            className="mx-auto mt-2 mb-2"
            style={{ borderRadius: 4 }}
          />
        </div>
      </div>
    </div>
  );
};

export default OversightSkeleton;
